import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnDestroy,
} from '@angular/core';
import { Subject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { TranslationService } from '@services/translation.service';

@Component({
    selector: 'app-input-date',
    templateUrl: './input-date.component.html',
    styleUrls: ['./input-date.component.scss'],
    standalone: false
})
export class InputDateComponent implements OnInit, OnDestroy {
  @Input() disabled: boolean = false;
  @Input() control: FormControl;
  @Input() placeholder: string = this.translation.getTranslatedContent(
    'select_a_date',
    'Select a Date'
  );
  @Input() onlyFutureDates: boolean; // avoid being able to select previous dates
  @Input() avoidToday: boolean; // avoid being able to select today's date
  @Input() useUTC: boolean = false; // set input/outputs/comparisons with UTC
  @Input() appendTo = 'body';
  @Input() dateControl = null;
  public minDate: Date | null = null;
  public disabledDates: Date[] = [];
  public dateFormat: string = 'mm/dd/yy';

  destroy$ = new Subject();

  constructor(private translation: TranslationService) {}

  ngOnInit(): void {
    this.setupDateFilters();

    if (this.control) {
      this.control.valueChanges.subscribe(value => {
        if (value instanceof Date) {
          // Just normalize to start of day in local time, no UTC conversion
          const localDate = new Date(value);
          localDate.setHours(0, 0, 0, 0);
          this.control.setValue(localDate, { emitEvent: false });
        }
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  private setupDateFilters(): void {
    // Create today's date at start of day in local time
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (this.onlyFutureDates) {
      this.minDate = today;
    }

    if (this.avoidToday) {
      if (this.onlyFutureDates) {
        // If we're already filtering for future dates, adjust minDate to tomorrow
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);
        this.minDate = tomorrow;
      } else {
        // Otherwise, add today to disabled dates
        this.disabledDates = [new Date(today)];
      }
    }
  }
}
